
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon
  }
})
export default class SingularityCanvasOption extends Vue {
  @Prop()
  title!: string;
  @Prop()
  description!: string;
  @Prop({ default: "SparklesSolidIcon" }) icon!: string;
}
